import React, { Component } from "react";
import { connect } from "react-redux";
import SideMenuLayoutWrapper from "../components/layout/SideMenu/SideMenuWrapper";
import { userSubscription } from "../store/sales/selectors";
import { getUser, getOrganization } from "../store/iam/selectors";
import { fetchOrganization } from "../store/iam/operations";

class SideBar extends Component {
    componentDidMount = (_) => {
        this.props.fetchOrganization();
    };

    render() {
        return (
            <SideMenuLayoutWrapper
                user={this.props.user}
                subscription={this.props.userSubscription}
                organization={this.props.organization}
            />
        );
    }
}

const mapStateToProps = (state) => ({
    userSubscription: userSubscription(state),
    user: getUser(state),
    organization: getOrganization(state)
});

export default connect(mapStateToProps, { fetchOrganization })(SideBar);
